<template>
	<div class="Header" v-if="UserInfo">
        <div class="HeaderTop">
            <img class="LogoImg" src="/static/logoSystem.png?v=21" alt="" />
            <el-button v-if="UserInfo.user_info.type==1" v-throttle type="primary" size="small" @click="ToggSystem">申请其他类型项目</el-button>
        </div>
        <div class="Banner">
          <!-- <div class="BannerAbs">
               <!-- <div class="BannerTit">{{"XXXX"||'全流程智能评审系统'}}</div> 
           </div> -->
            <el-carousel indicator-position="none">
               <el-carousel-item v-for="item in BannerData" :key="item">
                   <img :src="$Tools.ServeUrl()+item" alt="" />
               </el-carousel-item>
             </el-carousel>
        </div>
        <!-- <div class="NavS">
            <div class="NavsItem" v-for="i in Navs" :key="i.path" @click="GoPage(i)">
                <div class="NavsItemIcon">
                    <i class="iconfont" :class="i.icon"></i>
                </div>
                <div class="NavsItemTxt">{{i.system_name}}</div>
            </div>
        </div> -->
        <!-- <div class="NavHead" v-if="Navs.length>1">
            <el-button v-for="item in Navs" :key="item.id" :type="RowData.id != item.id?'info':'primary'" plain @click="ToggleSysType(item)">{{item.system_name}}</el-button>
        </div>
        <div class="NavHead" v-else>
            <el-tag v-for="item in Navs" :key="item.id" :type="RowData.id != item.id?'info':''" plain @click="ToggleSysType(item)">{{item.system_name}}</el-tag>
        </div> -->
        <div class="NavS">
            <div class="NavsItem" v-for="i in RowData" :key="i.id" @click="GoPage(RowData,i)">
                <div class="NavsItemIcon">
                    <i v-if="!i.icon" class="NavsItemFont el-icon-tickets"></i>
                    <i class="NavsItemFont" v-if="i.icon.startsWith('el-')" :class="i.icon"></i>
                    <i class="iconfont" v-if="!i.icon.startsWith('el-')" :class="i.icon"></i>
                </div>
                <div class="NavsItemTxt">{{i.system_name}}</div>
            </div>
            <div class="NoData" v-if="RowData.length==0">暂无项目，请申请项目</div>
        </div>
        <div class="NavS" v-if="UserInfo.user_info.type==1">
            <div class="NavsItem No" v-for="i in NoRowData" :key="i.id">
                <div class="NavsItemIcon No">
                    <i v-if="!i.icon" class="NavsItemFont el-icon-tickets"></i>
                    <i class="NavsItemFont" v-if="i.icon.startsWith('el-')" :class="i.icon"></i>
                    <i class="iconfont" v-if="!i.icon.startsWith('el-')" :class="i.icon"></i>
                </div>
                <div class="NavsItemTxt No">{{i.system_name}}</div>
            </div>
        </div>
         <el-dialog title="系统选择" :visible.sync="SystemData.SysBlon" width="40%" class="BorderRadius" :modal-append-to-body="false">
             <div class="DigItem">
                 <div class="DigItemTit MarBom">系统：</div>
                 <el-cascader class="Wid" size="medium" v-model="SystemData.SysId" :options="SystemList" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader>
             </div>
             <div slot="footer">
                 <el-button v-throttle size="small" @click="$Tools.ResetData(SystemData)">取消</el-button>
                 <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucSys">确定</el-button>
             </div>
         </el-dialog>
    </div>
</template>

<script>
	export default {
		data() {
			return {
                BannerData:"",
				Navs:[],
                RowData:"",
                NoRowData:"",
                SystemData:{
                    SysBlon:false,
                    SysId:[],
                },
                SystemList:[],
                // SystemName:"",
                UserInfo:"",
			};
		},
        mounted() {
            // this.Navs = JSON.parse(sessionStorage.getItem("Nav"));
            this.RowData = JSON.parse(sessionStorage.getItem("Nav"));
            this.NoRowData = JSON.parse(sessionStorage.getItem("NoNav"));
            this.UserInfo = JSON.parse(sessionStorage.getItem("USER-Info"));
            // this.SystemName = this.Navs[0].system_name;
            this.GetBanner();
        },
		methods: {
            ToggleSysType(row){
                if(row.system_code == 'expert_portal'){
                    this.GoPage(row);
                    return;
                }
                this.RowData = row;
                // this.SystemName = row.system_name;
            },
            GetBanner(){
                this.$get('api/auth/kv').then(res=>{
                    if(res){
                        this.BannerData = res.data;
                    }
                })
            },
            ToggSystem(){
                this.$Tools.ResetData(this.SystemData);
                this.$get('/api/auth/getAlls').then(res=>{
                    if(res){
                        this.SystemList = res.data;
                        this.SystemData.SysBlon = true;
                    }
                })
            },
            SucSys(){
                this.$post('/api/auth/ApplyAdd',{
                    system_id:this.SystemData.SysId,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.SystemData.SysBlon = false;
                    }
                })
            },
			GoPage(row,i){
                sessionStorage.setItem('SYSTEM-TOKEN',i.system_code);
                setTimeout(()=>{
                    if(this.UserInfo.user_info.type == '2'){
                        sessionStorage.setItem('SYSTEM-TOKEN',"expert_portal");
                        sessionStorage.setItem('SYSTEM-SubId',i.id);
                        setTimeout(()=>{
                            this.$router.push({path: "/ExpertIndex"});
                        },50)
                    }else{
                        sessionStorage.setItem("SYSTEM-Data",JSON.stringify(i))
                        this.$router.push({path: "/ModelIndex"});
                    }
                },50)
            },
		}
	}
</script>

<style scoped>
    .Header{
        padding-bottom: 40px;
    }
	.HeaderTop{
	    /* background: #095b95; */
	    padding:0 20px;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
        margin-bottom: 0;
    }
    .LogoImg{
        width: 550px;
        padding: 5px 0;
    }
    .Banner{
        height: 300px;
        position: relative;
    }
    .Banner img{
        width: 100%;
        height: 300px;
    }
    .Banner .BannerAbs{
        position: absolute;
        left: 10%;
        top: 50%;
        transform: translateY(-50%);
        color: #095b95;
    }
    .BannerAbs .BannerTit{
        font-size: 40px;
        font-weight: 700;
    }
    .BannerAbs .BannerFuTit{
        font-size: 14px;
        margin-top: 20px;
        border: 1px solid #095b95;
        border-radius: 20px;
        display: inline-block;
        padding: 5px 20px;
    }   
    .NoData{
        text-align: center;
        margin-top: 20px;
        font-size: 20px;
        color: #0f5c9e;
        width: 100%;
    }
    .NavS{
        width: 1000px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 15px;
    }
    .NavsItem{
        width: 23%;
        margin-top: 20px;
        cursor: pointer;
    }
    .NavsItem.No{
        cursor: not-allowed;
    }
    .NavsItemIcon{
        border-radius: 50%;
        border: 2px solid #095b95;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        margin: 0 auto;
    }
    .NavsItemIcon.No{
        border: 2px solid #ddd;
    }
    .NavsItemIcon .iconfont,
    .NavsItemIcon .NavsItemFont{
        font-weight: 700;
        color:#095b95;
        font-size: 30px;
    }
    .NavsItemIcon.No .iconfont,
    .NavsItemIcon.No .NavsItemFont{
        color:#ddd;
    }
    .NavsItemTxt{
        text-align: center;
        margin-top: 10px;
        font-weight: 700;
        font-size: 17px;
        color: #3c3c3c;
        height: 75px;
        overflow: hidden;
    }
    .NavsItemTxt.No{
        color:#ddd;
    }
    .NavHead{
        width: 750px;
        margin: 10px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
</style>